import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import './utils/Roboto-Regular-normal';
import App from './App';
import store from './store';
// import '../node_modules/@ru-digital-assets/ui-component/dist/index.css';
import './style/css/index.scss';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
